{
    "header": "פרטי הפעולה",
    "addHeader": "הזן פרטי פעולה",
    "type": "סוג",
    "add": "הוסף פעולה",
    "date": "תאריך",
    "actionType": "סוג הפעולה",
    "padiTo": "מוטב",
    "paymentType": "סוג תשלום",
    "amount": "סכום",
    "chekNo": "מס' צ'ק"
}